import React from 'react';
import {view} from '@sail/ui';

const basic = {
  rendered: (
    <view.div
      css={{
        padding: 'xxlarge',
        color: 'secondary',
        background: 'container',
        borderRadius: 'small',
      }}
    >
      This is a box.
    </view.div>
  ),
  source: `<Box
  css={{
    padding: 'xxlarge',
    color: 'secondary',
    background: 'container',
    borderRadius: 'small',
  }}
>
  This is a box.
</Box>`,
};

const border = {
  rendered: (
    <view.div
      css={{background: 'white', padding: 'medium', borderRadius: 'medium'}}
    >
      <view.div
        css={{
          padding: 'xlarge',
          border: '1px solid',
          borderColor: 'neutral',
          borderRadius: 'medium',
        }}
      >
        This box has a border
      </view.div>
    </view.div>
  ),
  source: `<Box
  css={{
    padding: 'xlarge',
    border: '1px solid',
    borderColor: 'neutral',
    borderRadius: 'medium',
  }}
>
  This box has a border
</Box>`,
};

export const BoxExamples = {basic, border};
